import { render, staticRenderFns } from "./RuleBidCap.vue?vue&type=template&id=3c0ca58d"
import script from "./RuleBidCap.vue?vue&type=script&lang=js"
export * from "./RuleBidCap.vue?vue&type=script&lang=js"
import style0 from "./RuleBidCap.vue?vue&type=style&index=0&id=3c0ca58d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports